const Platform = require('PSPlatform');

const WidgetChangerData = cc.Class({
    name: 'WidgetChangerData',
    properties: {
        aspectRatioTo: 0,
		isAlignTop: {
            default: false,
            notify: function() {
                if (this.isAlignTop) {
                    this.isAlignVerticalCenter = false;
                }
            }
        },
		isAlignBottom: {
            default: false,
            notify: function() {
                if (this.isAlignBottom) {
                    this.isAlignVerticalCenter = false;
                }
            }
        },
		isAlignLeft: {
            default: false,
            notify: function() {
                if (this.isAlignLeft) {
                    this.isAlignHorizontalCenter = false;
                }
            }
        },
		isAlignRight: {
            default: false,
            notify: function() {
                if (this.isAlignRight) {
                    this.isAlignHorizontalCenter = false;
                }
            }
        },
        isAlignVerticalCenter: {
            default: false,
            notify: function() {
                if (this.isAlignVerticalCenter) {
                    this.isAlignTop = false;
                    this.isAlignBottom = false;
                }
            }
        },
		isAlignHorizontalCenter: {
            default: false,
            notify: function() {
                if (this.isAlignHorizontalCenter) {
                    this.isAlignLeft = false;
                    this.isAlignRight = false;
                }
            }
        },
		top: {
            default: 0,
            visible: function() { return this.isAlignTop }
        },
		bottom: {
            default: 0,
            visible: function() { return this.isAlignBottom }
        },
		left: {
            default: 0,
            visible: function() { return this.isAlignLeft }
        },
		right: {
            default: 0,
            visible: function() { return this.isAlignRight }
        },
		horizontalCenter: {
            default: 0,
            visible: function() { return this.isAlignHorizontalCenter }
        },
		verticalCenter: {
            default: 0,
            visible: function() { return this.isAlignVerticalCenter }
        },
		isAbsoluteHorizontalCenter: {
            default: false,
            visible: function() { return this.isAlignHorizontalCenter }
        },
		isAbsoluteVerticalCenter: {
            default: false,
            visible: function() { return this.isAlignVerticalCenter }
        },
		isAbsoluteTop: {
            default: false,
            visible: function() { return this.isAlignTop }
        },
		isAbsoluteBottom: {
            default: false,
            visible: function() { return this.isAlignBottom }
        },
		isAbsoluteLeft: {
            default: false,
            visible: function() { return this.isAlignLeft }
        },
		isAbsoluteRight: {
            default: false,
            visible: function() { return this.isAlignRight }
        },
    }
});

cc.Class({
    extends: cc.Component,

    properties: {
        target: cc.Widget,
        desktopWidgetsData: [WidgetChangerData],
        handleMobile: false,
        mobileWidgetsData: {
            default: [],
            type: WidgetChangerData,
            visible: function () {
                return this.handleMobile
            }
        }
    },

    onLoad () {
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');

        if (!this.resizeManager) {
            this.node.removeComponent('PSWidgetAspectChanger');
            cc.warn('PSScaleAspectChanger: no resize manager found');
            return;
        }

        if (!this.target) {
            this.target = this.node.getComponent(cc.Widget);
        }

        if (!this.target) {
            this.node.removeComponent('PSWidgetAspectChanger');
            cc.warn('PSScaleAspectChanger: no target found');
            return;
        }

        this.originData = {};
        this.copyFromTo(this.target, this.originData);

        this.aspectData = (Platform.isMobile && this.handleMobile) ? this.mobileWidgetsData : this.desktopWidgetsData;

        this.aspectData.sort(function (a, b) {
            return a.aspectRatioTo - b.aspectRatioTo;
        });


        if (this.aspectData.length) {
            this.resizeManager.appendNode(this);
        } else {
            this.node.removeComponent('PSPositionAspectChanger');
        }

    },

    onDestroy() {
        this.resizeManager.removeNode(this);
    },

    copyFromTo (from, to) {
        if (!from  || !to) {
            return;
        }

        to.isAlignTop = from.isAlignTop;
        to.isAlignLeft = from.isAlignLeft;
        to.isAlignBottom = from.isAlignBottom;
        to.isAlignRight = from.isAlignRight;
        to.isAlignHorizontalCenter = from.isAlignHorizontalCenter;
        to.isAlignVerticalCenter = from.isAlignVerticalCenter;
        to.isAbsoluteTop = from.isAbsoluteTop;
        to.isAbsoluteBottom = from.isAbsoluteBottom;
        to.isAbsoluteLeft = from.isAbsoluteLeft;
        to.isAbsoluteRight = from.isAbsoluteRight;
        to.isAbsoluteHorizontalCenter = from.isAbsoluteHorizontalCenter;
        to.isAbsoluteVerticalCenter = from.isAbsoluteVerticalCenter;
        to.top = from.top;
        to.bottom = from.bottom;
        to.left = from.left;
        to.right = from.right;
        to.verticalCenter = from.verticalCenter;
        to.horizontalCenter = from.horizontalCenter;
    },

    onViewResize (_screenRatio, aspectRatio) {
        let index = -1;
        for(let i = 0; i < this.aspectData.length; i++) {
            const data = this.aspectData[i];

            if (aspectRatio < data.aspectRatioTo) {
                index = i;
                break;
            }
        }

        this._position(index)
    },

    _position (index) {
        if (index === -1) {
            this.copyFromTo(this.originData, this.target);
            return;
        }

        const data = this.aspectData[index];

        this.copyFromTo(data, this.target);
    }
});
